import namespace from "@rdfjs/namespace";
export const time = namespace("http://www.w3.org/2006/time#");
